const REVIEWED_KEY = "ironfleet-debrief:reviewed:v1";

export function loadReviewedIds(): Set<string> {
  try {
    const raw = localStorage.getItem(REVIEWED_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((item): item is string => typeof item === "string" && item.length > 0));
  } catch {
    return new Set();
  }
}

export function saveReviewedIds(ids: Iterable<string>): void {
  localStorage.setItem(REVIEWED_KEY, JSON.stringify([...ids]));
}
